import Vue from 'vue'

Vue.mixin({
    methods: {
        alertSignupSuccess() {
            this.$buefy.dialog.alert({
                type:'is-success',
                message: 'สมัครสมาชิกเรียบร้อยแล้ว กรุณาเข้าสู่ระบบ',
                confirmText:'ตกลง',
                onConfirm:()=>{
                    this.$router.push('/')
                }
            })
        },
        alertSignupFail() {
            this.$buefy.dialog.alert({
                type:'is-danger',
                message: 'สมัครสมาชิกล้มเหลว กรุณาลองใหม่',
                confirmText:'ตกลง'
            })
        },
        alertSignupEmailFail() {
            this.$buefy.dialog.alert({
                type:'is-danger',
                message: 'อีเมลนี้ถูกใช้งานแล้ว',
                confirmText:'ตกลง'
            })
        },
        alertFailError() {
            this.$buefy.dialog.alert({
                type:'is-danger',
                message: 'ระบบขัดข้อง กรุณาลองใหม่',
                confirmText:'ตกลง'
            })
        },
        alertCatchError() {
            this.$buefy.dialog.alert({
                type:'is-danger',
                message: 'เครือข่ายไม่เสถียร กรุณาติดต่อผู้ดูแล',
                confirmText:'ตกลง'
            })
        },
    },
  })
  